import { resolveSubmitUpload } from '#pplx/frontend/apps/ask/composer-ui/useSubmitAfterUploads.js';
import { hasCurrentImageUpload } from '#pplx/frontend/components/utils/fileUploadUtils.js';
export function isUploadInProgress(file) {
    return file.status === 'uploading' || file.status === 'parsing' || file.status === 'validating';
}
function toSubmitUpload(file) {
    return resolveSubmitUpload({
        hasStoredUrl: file.url !== undefined,
        id: file.id,
        status: file.status,
    });
}
/** Projects tracked files into submission readiness and recoverable attachments. */
export function projectFileAttachments({ attachmentMetadataById, files, }) {
    return {
        attachmentUrls: files.flatMap((file) => file.url !== undefined && toSubmitUpload(file).status === 'ready' ? [file.url] : []),
        fileAttachments: files.flatMap((file) => {
            if (file.url === undefined || toSubmitUpload(file).status !== 'ready')
                return [];
            const metadata = attachmentMetadataById.get(file.id) ?? attachmentMetadataById.get(file.url);
            return [
                {
                    filename: file.fileName,
                    url: file.url,
                    ...(metadata !== undefined ? { metadata } : {}),
                },
            ];
        }),
        isUploading: files.some((file) => toSubmitUpload(file).status === 'pending'),
        hasImageAttachments: hasCurrentImageUpload(files.map(({ file, id, url }) => ({ file, id, nextURL: url }))),
        submitUploads: files.map(toSubmitUpload),
        fileDescriptors: files.map((file) => ({
            ...toSubmitUpload(file),
            mediaType: file.file.size > 0 ? file.file.type : file.fileType,
            // Hydration uses an empty File placeholder; it is not evidence of an empty attachment.
            sizeBytes: file.file.size > 0 ? file.file.size : file.fileSize > 0 ? file.fileSize : null,
        })),
    };
}
//# sourceMappingURL=fileAttachmentProjection.js.map